import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';

const DEFAULT_OTHER_CONFIG = { autoHideSeconds: 0, autoHide: false };

export default function TimerEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [timerDisplayName, setTimerDisplayName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);
    const [flash, setFlash] = useState(eventModuleRow.flash);
    const [seconds, setSeconds] = useState(eventModuleRow.seconds ?? 0);
    const [other_config, setOtherConfig] = useState(
        eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 2
            ? eventModuleRow.other_config
            : DEFAULT_OTHER_CONFIG
    );

    useEffect(() => {
        setTimerDisplayName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
        setFlash(eventModuleRow.flash);
        setSeconds(eventModuleRow.seconds ?? 0);
        if (eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 2) {
            setOtherConfig(eventModuleRow.other_config);
        }
    }, [eventModuleRow]);

    function notify(overrides) {
        updateEventModuleRow({
            name: timerDisplayName,
            colour: bStyle,
            flash,
            seconds,
            other_config,
            module_type_id: eventModuleRow.module_type_id,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            ...overrides,
        });
    }

    function handleChange(e) {
        if (e.target.name === 'flash') {
            const newFlash = !flash;
            setFlash(newFlash);
            notify({ flash: newFlash });
        } else if (e.target.name === 'timerDisplayName') {
            const newName = e.target.value;
            setTimerDisplayName(newName);
            notify({ name: newName });
        } else if (e.target.name === 'seconds') {
            const newSeconds = e.target.value;
            setSeconds(newSeconds);
            notify({ seconds: newSeconds });
        } else if (e.target.name === 'autoHide') {
            const newConfig = { ...other_config, autoHide: !other_config.autoHide };
            setOtherConfig(newConfig);
            notify({ other_config: newConfig });
        } else if (e.target.name === 'autoHideSeconds') {
            const newConfig = { ...other_config, autoHideSeconds: e.target.value };
            setOtherConfig(newConfig);
            notify({ other_config: newConfig });
        }
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        notify({ colour: newStyle });
    }

    const inputStyle = { width: '100%' };
    const secsStyle = { width: '15%', marginLeft: '10px', marginRight: '10px' };
    const flashStyle = { marginRight: '10px' };
    const rowStyle = { marginBottom: '10px', marginTop: '10px' };
    const spanFlashStyle = { display: flash ? 'inline-table' : 'none' };
    const spanAutoHideStyle = { display: other_config.autoHide ? 'inline-table' : 'none' };

    return (
        <div>
            <div className="row" style={rowStyle}>
                <div className="col-lg-6 col-md-6">
                    <input type="text" style={inputStyle} className="form-control input-md"
                        name="timerDisplayName" value={timerDisplayName}
                        onChange={handleChange} placeholder="Timer Name" />
                </div>
                <div className="col-lg-6 col-md-6">
                    <SelectColourButton
                        title="Select Colour"
                        groupingSequence={eventModuleRow.event_grouping_seq}
                        selectedColour={colourSelected}
                        bStyle={bStyle} />
                </div>
            </div>
            <div className="row" style={rowStyle}>
                <div className="col-lg-12 col-md-12">
                    <input name="flash" style={flashStyle} checked={flash}
                        onChange={handleChange} type="checkbox" value="" />
                    Flash Screen
                    <span style={spanFlashStyle}>
                        <input type="text" style={secsStyle} className="form-control input-md"
                            name="seconds" value={seconds}
                            onChange={handleChange} placeholder="Secs" />
                        seconds before end
                    </span>
                </div>
            </div>
            <div className="row" style={rowStyle}>
                <div className="col-lg-12 col-md-12">
                    <input name="autoHide" style={flashStyle} checked={other_config.autoHide}
                        onChange={handleChange} type="checkbox" value="" />
                    Auto hide message at end
                    <span style={spanAutoHideStyle}>
                        <input type="text" style={secsStyle} className="form-control input-md"
                            name="autoHideSeconds" value={other_config.autoHideSeconds}
                            onChange={handleChange} placeholder="Secs" />
                        seconds after display
                    </span>
                </div>
            </div>
        </div>
    );
}
